'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SocialFacebookIcon = function SocialFacebookIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Facebook' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M4.88307812,4 C4.395375,4 4,4.395375 4,4.88307812 L4,19.1169219 C4,19.6045937 4.39523438,20 4.88307812,20 L12.546875,20 L12.546875,13.8125 L10.46875,13.8125 L10.46875,11.390625 L12.546875,11.390625 L12.546875,9.60834375 C12.546875,7.54175 13.8089531,6.4164375 15.6524375,6.4164375 C16.5354531,6.4164375 17.2944063,6.4821875 17.515625,6.51157812 L17.515625,8.67129687 L16.2442656,8.671875 C15.241125,8.671875 15.046875,9.1485625 15.046875,9.84807812 L15.046875,11.390625 L17.4451094,11.390625 L17.1328281,13.8125 L15.046875,13.8125 L15.046875,20 L19.1169375,20 C19.6046406,20 20,19.6046406 20,19.1169375 L20,4.88307812 C20,4.395375 19.604625,4 19.1169062,4 L4.88307812,4 Z"
    })]
  }));
};
SocialFacebookIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SocialFacebookIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Facebook'",
        "computed": false
      },
      "required": false
    }
  }
};
var SocialFacebookIcon$1 = SocialFacebookIcon;

exports.default = SocialFacebookIcon$1;
//# sourceMappingURL=SocialFacebookIcon.js.map
